import { createSlice } from '@reduxjs/toolkit';

const getInitialAuthState = () => {
  const accessToken = localStorage.getItem("access_token");
  // const user = localStorage.getItem("user");
  // const subRole = localStorage.getItem("sub_role");
  // const subBranch = localStorage.getItem("sub_branch"); 
  // if (accessToken && user) {
    // return {
    //   isAuthenticated: true,
    //   user: {
    //     name: user,
    //     email: localStorage.getItem("email"),
    //     profile_photo_url: localStorage.getItem("profile_photo_url") || "",
    //     is_subuser: localStorage.getItem("is_subuser") === "true",
    //     subuser_id: localStorage.getItem("subuser_id") || null,
    //     sub_branch: subBranch || null,
    //   },
    //   sub_role: subRole ? JSON.parse(subRole) : [],
    //   showLoginNotification: false,
    // };
    
  //}
  return {
    isAuthenticated: !!accessToken,
    user: null,
    sub_role: [],
    showLoginNotification: false,
  };
};

const initialState = getInitialAuthState();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      // state.isAuthenticated = true;
      // state.user = action.payload.user;
      // state.sub_role = action.payload.sub_role || [];
      // state.showLoginNotification = true;
      // localStorage.setItem("sub_role", JSON.stringify(state.sub_role));
      // if (action.payload.user.sub_branch) {
      //   localStorage.setItem("sub_branch", action.payload.user.sub_branch); // 新增
      // }
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.sub_role = action.payload.sub_role || [];
      state.showLoginNotification = true;
    },
    logout: (state) => {
      // state.isAuthenticated = false;
      // state.user = null;
      // localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("email");
      localStorage.removeItem("main_id");
      localStorage.removeItem("salesman_id");
      localStorage.removeItem("profile_photo_url");
      localStorage.removeItem("sub_role");
      localStorage.removeItem("is_subuser");
      localStorage.removeItem("subuser_id");
      localStorage.removeItem("sub_branch");
      localStorage.removeItem("company_name");
      state.isAuthenticated = false;
      state.user = null;
      state.sub_role = [];
      localStorage.removeItem("access_token");
      localStorage.removeItem("sso_session_key");
    },
    clearLoginNotification: (state) => {
      state.showLoginNotification = false;
    },
    // setUserName: (state, action) => {
    //   if (state.user) {
    //     state.user.name = action.payload;
    //   }
    // },
    // setUserProfilePhoto: (state, action) => {
    //   if (state.user) {
    //     state.user.profile_photo_url = action.payload;
    //     // localStorage.setItem("profile_photo_url", action.payload);
    //   }
    // },
    setUserProfilePhoto: (state, action) => {
      if (state.user) {
        state.user = {
          ...state.user,
          profile_photo_url: action.payload,
        };
      }
    },
    setUserName: (state, action) => {
      if (state.user) {
        state.user = {
          ...state.user,
          name: action.payload,
        };
      }
    },
    setSubRole: (state, action) => {
      state.sub_role = action.payload || [];
      // localStorage.setItem("sub_role", JSON.stringify(state.sub_role));
    }
  },
});

export const { login, logout, clearLoginNotification, setUserName, setUserProfilePhoto, setSubRole } = authSlice.actions;
export default authSlice.reducer;